export interface State {
  data: any;
  isLoading: boolean;
  error: string;
  isLoggedIn: boolean;
  connectionCount: number;
}

export const initialState: State = {
  data: { premium_status: 'subscribed' }, //this ensures that the premium block on the ui comes up smoothly. if this is removd then for premium users when then login, the premium block comes and then disappears
  isLoading: false,
  error: null,
  isLoggedIn: false,
  connectionCount: null,
};
